import { render, staticRenderFns } from "./Middleware.vue?vue&type=template&id=31cf0120&"
import script from "./Middleware.vue?vue&type=script&lang=js&"
export * from "./Middleware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports